import { modelHelperModule } from './model-helper';
import * as StringUtils from '../utils/string-utils';
import { getUser } from '../utils/account-utils/account-utils';

export const assessmentResultReviewModelModule = angular
  .module('Q.models.assessment-result-review', [modelHelperModule])

  .factory('AssessmentResultReview', function (DS, ModelHelper, $injector) {
    const currentUser = getUser.bind(null, $injector);

    const AssessmentResultReview = ModelHelper.defineResource({
      name: 'AssessmentResultReview',
      endpoint: 'assessment_result_reviews',

      methods: {
        isMyReview() {
          return this.reviewedBy === currentUser();
        },
        reviewerName(staffName = 'Qualified Staff') {
          return (
            (this.reviewedBy && this.reviewedBy.nameOrEmail) ||
            (this.reviewedByStaff ? staffName : '(Unknown Reviewer)')
          );
        },
        isSubmitted() {
          return this.state === 'submitted';
        },
        shouldShow() {
          return (
            this.isMyReview() || !this.reviewedByStaff || this.isSubmitted()
          );
        },
      },
      staticMethods: {
        // starts or retrieves an assessment-result-review for the given assessment result
        start(assessmentResult, teamMember, opts = {}) {
          let tm = teamMember || currentUser();
          if (!tm || tm.$type !== 'TeamMember') {
            throw new Error(
              'Unable to create assessment result review without a team member',
            );
          }
          let attr = {
            assessmentResultId: assessmentResult.id,
            reviewedById: tm.id,
          };
          return AssessmentResultReview.fetchOrCreateWhere(
            { where: attr },
            attr,
            opts,
          );
        },
        getFor(assessmentResult, teamMember) {
          let tm = teamMember || currentUser();
          return (
            tm &&
            AssessmentResultReview.filter({
              assessmentResultId: assessmentResult.id,
              reviewedById: tm.id,
            })[0]
          );
        },
        reviewSorter(a, b) {
          const user = currentUser();
          if (a.reviewedBy === user) {
            return -1;
          } else if (b.reviewedBy === user) {
            return 1;
          } else if (a.reviewedByStaff !== b.reviewedByStaff) {
            // puts staff reviews at the bottom
            return a.reviewedByStaff - b.reviewedByStaff;
          } else if (a.reviewedBy && b.reviewedBy) {
            return StringUtils.compareIgnoreCase(
              a.reviewerName(),
              b.reviewerName(),
            );
          }
          return 0;
        },
      },

      relations: {
        hasOne: {
          TeamMember: {
            localField: 'reviewedBy',
            localKey: 'reviewedById',
          },
        },
        hasMany: {
          SolutionReview: {
            localField: 'solutionReviews',
            foreignKey: 'assessmentResultReviewId',
          },
        },
        belongsTo: {
          Assessment: {
            localField: 'assessment',
            localKey: 'assessmentId',
          },
          AssessmentResult: {
            localField: 'assessmentResult',
            localKey: 'assessmentResultId',
          },
          TeamCandidate: {
            localField: 'teamCandidate',
            localKey: 'teamCandidateId',
          },
        },
      },

      meta: {
        fetchOnPush: (data) => {
          // only store the review if we have the assessment result
          return DS.get('AssessmentResult', data.assessmentResultId || '');
        },
        track: {
          create: true,
        },
      },
    });

    return AssessmentResultReview;
  });
